export const findings  = [
    {
        title: "Flair",
        value: "flair",
        options: [
            {
                text: "Increased",
                value: "increased"
            },
            {
                text: "Normal",
                value: "normal"
            },
            {
                text: "Decreased",
                value: "decreased"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "T2",
        value: "t2",
        options: [
            {
                text: "Increased",
                value: "increased"
            },
            {
                text: "Normal",
                value: "normal"
            },
            {
                text: "Decreased",
                value: "decreased"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "T1",
        value: "t1",
        options: [
            {
                text: "Increased",
                value: "increased"
            },
            {
                text: "Normal",
                value: "normal"
            },
            {
                text: "Decreased",
                value: "decreased"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "Contrast Enhancement",
        value: "contrast_enhancement",
        options: [
            {
                text: "Yes",
                value: "yes"
            },
            {
                text: "No",
                value: "no"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "Susceptibility Artifact",
        value: "susceptibility_artifact",
        options: [
            {
                text: "Yes",
                value: "yes"
            },
            {
                text: "No",
                value: "no"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {                     
        title: "Diffusion",
        value: "diffusion",
        options: [
            {
                text: "Restricted",
                value: "restricted"
            },
            {
                text: "Normal",
                value: "normal"
            },
            {
                text: "Facilitated",
                value: "facilitated"
            },
            {
                text: "N/A",
                value: "NA"
            },
        ]
    },
    {
        title: "Size",
        value: "size",
        options: [
            {
                text: "< 1 cm",
                value: "small"
            },
            {
                text: "1 - 3 cm",
                value: "medium"
            },
            {
                text: "> 3 cm",
                value: "large"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "Mass Effect",
        value: "mass_effect",
        options: [
            {
                text: "Positive",
                value: "positive"
            },
            {
                text: "None",
                value: "none"
            },
            {
                text: "Negative (atrophy)",
                value: "negative"
            },
            {
                text: "N/A",
                value: "NA"
            },
        ]
    },
    {
        title: "Number of Lesions",
        value: "num_lesion",
        options: [
            {
                text: "Single",
                value: "single"
            },
            {
                text: "Multiple",
                value: "multiple"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "Dominant Pattern",
        value: "dominant_pattern",
        options: [
            {
                text: "Homogeneous",
                value: "homogeneous"
            },
            {
                text: "Ring",
                value: "ring"
            },
            {
                text: "Heterogeneous",
                value: "heterogeneous"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    },
    {
        title: "Side",
        value: "side",
        options: [
            {
                text: "Left",
                value: "left"
            },
            {
                text: "Right",
                value: "right"
            },
            {
                text: "Bilateral Symmetric",
                value: "bilateral_symmetric"
            },
            {
                text: "Bilateral Asymmetric",
                value: "bilateral_asymmetric"
            },
            {
                text: "N/A",
                value: "NA"
            }
        ]
    }
]

export const location = [
    {
        title: "Cortical Gray Matter",
        value: "Cortical Gray",
        options: [
            {
                text: "Frontal",
                value: "Frontal"
            },
            {
                text: "Parietal",
                value: "Parietal"
            },
            {
                text: "Occipital",
                value: "Occipital"
            },
            {
                text: "Temporal",
                value: "Temporal"
            }
        ]
    },
    {
        title: "Cerebral White Matter",
        value: "Cerebral White Matter",
        options: [
            {
                text: "Frontal",
                value: "Frontal"
            },
            {
                text: "Parietal",
                value: "Parietal"
            },
            {
                text: "Occipital",
                value: "Occipital"
            },
            {
                text: "Temporal",
                value: "Temporal"
            }
        ]
    },
    {
        title: "Deep Gray White Matter",
        value: "Deep Gray White",
        options: [
            {
                text: "Caudate",
                value: "Caudate"
            },
            {
                text: "Putamen",
                value: "Putamen"
            },
            {
                text: "Global Pallidus",
                value: "Global Pallidus"
            },
            {
                text: "Thalamus",
                value: "Thalamus"
            },
            {
                text: "Internal Capsule",
                value: "Internal Capsule"
            }
        ]
    },
    {
        title: "Brain Stem",
        value: "Brain Stem",
        options: [
            {
                text: "Mesencephalon",
                value: "Mesencephalon"
            },
            {
                text: "Pons",
                value: "Pons"
            },
            {
                text: "Medulla",
                value: "Medulla"
            },
        ]
    },
    {
        title: "Cerebellum",
        value: "Cerebellum",
        options: [
            {
                text: "Hemisphere",
                value: "Hemisphere"
            },
            {
                text: "Vermis",
                value: "Vermis"
            },
            {
                text: "Tonsil",
                value: "Tonsil"
            },
        ]
    },
    {
        title: "Intraventricular",
        value: "Intraventricular",
        options: [
            {
                text: "LAT",
                value: "LAT"
            },
            {
                text: "III",
                value: "III"
            },
            {
                text: "IV",
                value: "IV"
            },
        ]
    },
    {
        title: "Extracerebral",
        value: "Extracerebral",
        options: [
            {
                text: "Epidural",
                value: "Epidural"
            },   
            {
                text: "Subdural",
                value: "Subdural"
            },
            {
                text: "Subarachnoid",
                value: "Subarachnoid"
            }
        ]
    },
    {
        title: 'N/A',
        value: "NA",
        options: []
    }
]

